import React from "react";

const NonUSDAmount = ({ row }) => {
  return <div>{row?.nonUSDAmount?.toLocaleString()}</div>;
};

export default NonUSDAmount;
